import { z } from "zod";
import { idSchema, readinessSchema } from "@amber/contracts";
import { platformRefSchema } from "@amber/collection/contracts";

export const SEARCH_LANGUAGES = ["en", "de", "other"] as const;

export const passageSearchSchema = z.strictObject({
  q: z.string().trim().min(1).max(200),
  limit: z.coerce.number().int().min(1).max(100).optional(),
  offset: z.coerce.number().int().min(0).optional(),
  person: idSchema("prf").optional(),
  language: z.enum(SEARCH_LANGUAGES).optional(),
  readiness: readinessSchema.optional(),
  corrected: z.enum(["yes", "no"]).optional(),
});
export type PassageSearch = z.infer<typeof passageSearchSchema>;

export const snippetSegmentSchema = z.strictObject({ text: z.string(), match: z.boolean() });
export type SnippetSegment = z.infer<typeof snippetSegmentSchema>;

export const passageHitSchema = z.strictObject({
  unit_id: z.string(),
  item_id: idSchema("itm"),
  communication: z.number().int().positive(),
  title: z.string(),
  platform: platformRefSchema,
  speaker: z.string(),
  profile_id: idSchema("prf").nullable(),
  start_ms: z.number().int().nullable(),
  language: z.string().nullable(),
  snippet: z.array(snippetSegmentSchema),
  readiness: z.strictObject({ result: readinessSchema, label: z.string() }).nullable(),
  corrected: z.boolean(),
  other_copies: z.number().int().nonnegative(),
  href: z.string(),
});
export type PassageHit = z.infer<typeof passageHitSchema>;
